const ASSET_STATUS = {
  ACTIVE: 'Active',
  PHASED_OUT: 'Phased out',
  DRAFT: 'Draft',
  DEACTIVATED: 'Deactivated',
};

export default ASSET_STATUS;
